"use-strict";
/* global $ */



import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
window.$ = window.jQuery = require('jquery');
import Barba from 'barba.js';
// var imagesLoaded = require('imagesloaded');
// imagesLoaded.makeJQueryPlugin($);
// require("select2-full");
import Swiper from 'swiper/dist/js/swiper.js';
import interact from 'interactjs';
// import 'fullpage.js/vendors/easings.min.js';
// require('fullpage.js/vendors/scrolloverflow.min.js');
// import fullpage from 'fullpage.js'; 
// import ScrollMagic from 'ScrollMagic';
// import 'animation.gsap';
// import 'debug.addIndicators';
// import EasyPZ from 'easypz';
// import noUiSlider from 'nouislider';
// require('malihu-custom-scrollbar-plugin-concat');
// require('jquery-background-video/bgvideo.js');
require('waypoints/lib/noframework.waypoints.min');
// import panzoom from 'panzoom';
// import Plyr from 'plyr';
// import hoverintent from 'hoverintent';
import 'parsleyjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import anime from 'animejs';
import 'cookieconsent';
import objectFitImages from 'object-fit-images';

var Common = {
    lastScrollPos: 0,
    $container: null,
    menuSliders: [],
    popupInstances: [],
    sidebarInstances: [],
    menuStatus: null,
    sectionSlider: null,
    resize: null,
    originIndex: 0,
    newIndex: 0,
    script: null,
    init: function(){
        history.scrollRestoration = "manual";
        Common.detectDevice();
        Common.initBarba();
        Common.detectIE();
        if($('html').hasClass('ie')){
            window.lazySizesConfig = window.lazySizesConfig || {};
            lazySizesConfig.preloadAfterLoad = true;
        }

        // $('html').data('font-size', 'font-large');
        // document.addEventListener('contextmenu', event => event.preventDefault());
        objectFitImages(null, {watchMQ:true});
        // // events
        // // $(document).on('click', '.nav-category-button button', Common.openMenuDrawer);
        // // $(document).on('mouseleave', '.menu-bar', Common.closeMenu);
        // $(document).on('click touch', '#menu-toggle', Common.toggleMenu);
        // $(document).on('mouseenter', 'html.desktop .language-toggle', Common.openLang);
        // $(document).on('touchend', 'html.mobile .language-toggle', Common.toggleLang);
        // $(document).on('mouseleave', 'html.desktop .language-toggle', Common.closeLang);
        // $(document).on('mouseenter', 'html.desktop .nav-toggle', Common.openNav);
        // $(document).on('touchend', 'html.mobile .nav-toggle', Common.toggleNav);
        // $(document).on('mouseleave', 'html.desktop .nav-toggle', Common.closeNav);
        // $(window).on('resize orientationchange', Common.video2Cover);
        
        // $(window).on("orientationchange", function(){
        //     window.location.reload(false); 
        // })

        window.cookieconsent.initialise({
          "palette": {
            "popup": {
              "background": "#000"
            },
            "button": {
              "background": "#f1d600"
            }
          },
          "position" : "top",
          "theme": "classic",
          "content": {
            "message": 'This website uses cookies to ensure you get the best experience on our website.',
            "link": 'More Info',
            "href": privacyPageUrl,
            "dismiss": "<svg height='329pt' viewBox='0 0 329.26933 329' width='329pt' xmlns='http://www.w3.org/2000/svg' fill='#ffffff'><path d='m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0'/></svg>",
          },
          "elements": {
            "messagelink": '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}">{{link}}</a></span>',
          }
        });
    },
    initBarba: function(){
        Barba.Pjax.Dom.containerClass = "transition-container";
        Barba.Pjax.Dom.wrapperId = "transition-wrapper";
        Barba.Pjax.Dom.dataNamespace = "template";
        Barba.Utils.xhrTimeout = 10000;
        Barba.Pjax.cacheEnabled = false;
        Barba.Dispatcher.on('newPageReady', function(current, prev, container) {
            Common.$container = $(container);
            window.scrollTo(0, 0);
            // Common.layout(Common.$container);
            

            // events
            const drag = interact(Common.$container.find('.customer-service-draggable')[0]).draggable({
                // origin: 'self',
                inertia: true,
                modifiers: [
                  interact.modifiers.restrictRect({
                    restriction: 'parent',
                    endOnly: true
                  })
                ],
                listeners: {
                    move: Common.dragMoveListener
                }
            });


            // $(document).one('scroll', function(){
            //     anime({
            //         targets: $('#header>.logo')[0],
            //         opacity: 0,
            //         duration: 300,
            //         easing: 'easeOutCubic',
            //         complete: function(){
            //             $('#header>.logo').hide();
            //         }
            //     });
            // });

            // $('#header .overlay').on('click', Common.closeMenu);

            // Common.arrowAnimation();
            // Common.$container.find('.scroll-indicator.down').on("click touch", function() {
            //     Common.sectionSlider.slideNext();
            // });
            // Common.$container.find('.scroll-indicator.up').on("click touch", function() {
            //     Common.sectionSlider.slidePrev();
            // });

            // Common.$container.find('.open-popup').on('click', function(e){
            //     var $content = $(e.currentTarget).find('.scrollable-popup-content');
            //     var popup = new ScrollablePopup();
            //     popup.open($content);
            //     if(typeof fullpage_api !== "undefined"){
            //         fullpage_api.destroy();
            //     }
            //     // fullpage_api.setAutoScrolling(false);
            //     $(document).scrollTop(0);

            //     // popup.once('close', function(){
            //     //     if(!Common.$container.hasClass('detail')){
            //     //         Common.initFullpage(Common.$container, '', true);
            //     //     }
            //     // });
            // });

            // Common.$container.find('.font-size-selector button').on("click touch", function() {
            //     var size = $(this).data('size');
            //     $('html').removeClass('font-small').removeClass('font-medium').removeClass('font-large').addClass(size);
            //     $('html').data('font-size', size);
            //     Common.$container.find('.font-size-selector button').removeClass('active');
            //     Common.$container.find('.font-size-selector button[data-size='+size+']').addClass('active');
            // });

            // Common.$container.find('.font-size-selector button').each(function() {
            //     if($('html').hasClass('landing')) return false;
            //     var size = $('html').data('font-size');
            //     if($(this).data('size') == size){
            //         $(this).addClass('active');
            //     }else{
            //         $(this).removeClass('active');
            //     }
            // });

            Common.$container.find('#visit-form-1 button[type="submit"]').on('click', function(e){
                e.preventDefault();

                var valid = Common.checkForm(Common.$container.find('#visit-form-1'));

                if(valid){
                    var date = Common.$container.find('#visit-form-1 input[name="date"]').val();
                    var time = Common.$container.find('#visit-form-1 input[name="time"]:checked').val();

                    Common.$container.find('#visit-form-2  input[name="date"]').val(date + ' ' + time);

                    var target = $(this).data('to');
                    Common.$container.find('.customer-service .step').removeClass('active');
                    Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');
                }
            });

            Common.$container.find('#visit-form-2 button[type="submit"]').on('click', function(e){
                e.preventDefault();
                var $this = $(this);
                var $form = Common.$container.find('#visit-form-2');
                var valid = Common.checkForm($form);

                if(valid){
                    $.ajax({
                        type: "POST",
                        url: '/wp-admin/admin-ajax.php',
                        dataType:"json",
                        data: $form.serialize(),
                        cache: false,
                        beforeSend: function(){
                            $form.find('button[type=submit]').addClass('loading').attr('disabled', 'disabled');
                        },
                        success: function(data){
                            if(data['success']){
                                $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');

                                var target = $this.data('to');
                                Common.$container.find('.customer-service .step').removeClass('active');
                                Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');
                            }

                            $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');
                        }
                    });
                    
                }
            });

            Common.$container.find('#enquiry-form-1 button[type="submit"]').on('click', function(e){
                e.preventDefault();

                var valid = Common.checkForm(Common.$container.find('#enquiry-form-1'));

                if(valid){
                    var name = Common.$container.find('#enquiry-form-1 [name="name"]').val();
                    var email = Common.$container.find('#enquiry-form-1 [name="email"]').val();
                    var phone = Common.$container.find('#enquiry-form-1 [name="phone"]').val();
                    var message = Common.$container.find('#enquiry-form-1 [name="message"]').val();
                    var source = Common.$container.find('#enquiry-form-1 [name="source[]"]:checked').map(function() {
                        return this.value;
                    }).get();

                    Common.$container.find('#enquiry-form-3  [name="name"]').val(name);
                    Common.$container.find('#enquiry-form-3  [name="email"]').val(email);
                    Common.$container.find('#enquiry-form-3  [name="phone"]').val(phone);
                    Common.$container.find('#enquiry-form-3  [name="message"]').val(message);
                    Common.$container.find('#enquiry-form-3  [name="source"]').val(source);

                    var target = $(this).data('to');
                    Common.$container.find('.customer-service .step').removeClass('active');
                    Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');
                }
            });

            Common.$container.find('#enquiry-form-2 button[type="submit"]').on('click', function(e){
                e.preventDefault();

                var valid = Common.checkForm(Common.$container.find('#enquiry-form-2'));

                if(valid){
                    var room = Common.$container.find('#enquiry-form-2 input[name="room"]:checked').val();

                    Common.$container.find('#enquiry-form-3  input[name="room"]').val(room);

                    var target = $(this).data('to');
                    Common.$container.find('.customer-service .step').removeClass('active');
                    Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');
                }
            });

            Common.$container.find('#enquiry-form-3 button[type="submit"]').on('click', function(e){
                e.preventDefault();
                var $this = $(this);
                var $form = Common.$container.find('#enquiry-form-3');
                var valid = Common.checkForm($form);

                if(valid){
                    $.ajax({
                        type: "POST",
                        url: '/wp-admin/admin-ajax.php',
                        dataType:"json",
                        data: $form.serialize(),
                        cache: false,
                        beforeSend: function(){
                            $form.find('button[type=submit]').addClass('loading').attr('disabled', 'disabled');
                        },
                        success: function(data){
                            if(data['success']){
                                $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');

                                var target = $this.data('to');
                                Common.$container.find('.customer-service .step').removeClass('active');
                                Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');
                            }

                            $form.find('button[type=submit]').removeClass('loading').removeAttr('disabled');
                        }
                    });
                    
                }
            });

            Common.$container.find('.ps-image').on("click touch", Common.imagesZoom);

            Common.$container.find('.customer-service button.option, .customer-service button.back, .customer-service button.submit:not([type="submit"]),.customer-service button.home,.customer-service button.to').on('click', function(e){
                var target = $(this).data('to');
                Common.$container.find('.customer-service .step').removeClass('active');
                Common.$container.find('.customer-service .step[data-step="'+target+'"]').addClass('active');

                if(target == 0){
                    Common.$container.find('.customer-service form').each(function(){
                        this.reset();
                    });
                }
            });

            Common.$container.find('.customer-service .dialog').on('click', function(e){
                if($('html').hasClass('desktop')){
                    Common.$container.find('.customer-service-draggable').addClass('active');
                }
            });

            Common.$container.find('.customer-service-draggable button.open').on('click', function(e){
                Common.$container.find('.customer-service .step').removeClass('active');
                Common.$container.find('.customer-service .step[data-step="0"]').addClass('active');
                Common.$container.find('.customer-service-draggable').toggleClass('active');
            });

            Common.$container.find('.customer-service .dialog button.close').on('click', function(e){
                Common.$container.find('.customer-service-draggable').removeClass('active');
            });

            $(document).on('click', function(e){
                if(!$(e.target).closest('.customer-service').length){
                    Common.$container.find('.customer-service-draggable').removeClass('active');
                }
                
            });
        });
        Barba.Pjax.getTransition = function() {
            return Common.pageTransition;
        };
    },
    dragMoveListener: function (event) {
      var target = event.target;
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || parseFloat($(target).css('right'))) - event.dx;
      var y = (parseFloat(target.getAttribute('data-y')) || parseFloat($(target).css('top'))) + event.dy;

      // translate the element
      target.style.right = x + 'px';
      target.style.top = y + 'px';


      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    pageTransition: Barba.BaseTransition.extend({
        start: function() {
            Promise
                .all([this.newContainerLoading, this.fadeOut()])
                // .then(this.fadeOut.bind(this))
                .then(this.fadeIn.bind(this));
        },
        fadeOut: function() {
            var deferred = Barba.Utils.deferred();

            $("html").removeClass("landing");

            $("#transition-animation").css({
                'pointer-events': 'all',
                opacity: 1
            });

            setTimeout(function(){

                deferred.resolve();
            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 1,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     complete: function(){
            //         deferred.resolve();
                    
            //     }
            // });
            return deferred.promise;
        },
        fadeIn: function() {
            // window.scrollTo(0, 0);
            var _this = this;
            var $container = $(this.newContainer);
            $container.scrollTop(0);
        
            // anime({
            //  targets: this.newContainer,
            //  opacity: 1,
            //  easing: 'easeOutCubic',
            //  duration: 500
            // });
            _this.done();
            
        }
    }),
    pageTransitionLeave: function(){

    },
    pageTransitionEnter: function($container){
        return new Promise(function(resolve){
            // $("#transition-animation .layer-1").show();
            // $("#transition-animation .opening").hide();
            Common.$container.show();
            resolve();
            $("#transition-animation").css({
                opacity: 0
            });

            setTimeout(function(){
                $("#transition-animation").css({
                    'pointer-events': 'none',
                });
                resolve();

            }, 500);
            // anime({
            //     targets: $("#transition-animation")[0],
            //     opacity: 0,
            //     easing: 'easeOutCubic',
            //     duration: 300,
            //     begin: function(){
            //         Common.$container.show();
            //         resolve();
            //     },
            //     complete: function(){
                    
            //     }
            // });
        });
    },
    fitMain: function(){
        var windowHeight = $(window).height();
        var headerHeight = Common.$container.find('#header').outerHeight();
        var footerHeight = Common.$container.find('#footer').outerHeight();
        var $main = Common.$container.find('#main');

        if($main.hasClass('show-header') && $main.hasClass('show-footer')){
            var height = windowHeight - headerHeight - footerHeight;
            $main.height(height);
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('slideshow')){
            var height = windowHeight;
            $main.outerHeight(height);
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('fullpage')){
            var height = windowHeight -  footerHeight;
            $main.css({
                "min-height": height
            });
        }else if($main.hasClass('fixfull')){
            var height = windowHeight -  footerHeight;
            $main.css({
                "height": height
            });
        }
        
    },
    checkForm: function($form){
        var validator = $form.parsley({
            errorsContainer: function(el){
                return $(el.$element).closest('.input-wrapper').find('.error-container');
            },
            classHandler: function (el) {
                if(el.$element.is("[type='radio']")) return el.$element.closest('.radio-set');
                return el.$element;
            },
        });
        return validator.validate();
    },
    loadScript: function (src, async, defer) {
        return new Promise(function (resolve, reject) { 
            if($('script[src="'+ src +'"]').length > 0){
                resolve();
            }else{
                var s;
                Common.script = document.createElement('script');
                Common.script.src = src;
                Common.script.onload = resolve;
                Common.script.onerror = reject;
                if(async) Common.script.async = true;
                if(defer) Common.script.defer = true;
                document.head.appendChild(Common.script);
            }
        });
    },
    openLang: function(){
        anime({
            targets: Common.$container.find('.language-toggle>.wrapper')[0],
            height: $('html').hasClass('ie') ? 105 : 102,
            easing: 'easeOutCubic',
            duration: 800
        });
        
    },
    closeLang: function(){
        anime({
            targets: Common.$container.find('.language-toggle>.wrapper')[0],
            height: 1,
            easing: 'easeOutCubic',
            duration: 800
        });
    },
    toggleLang: function(){
        var $toggle = Common.$container.find('.language-toggle');
        if($toggle.hasClass('active')){
            Common.closeLang();
        }else{
            Common.openLang();
        }
        $toggle.toggleClass('active');
    },
    openNav: function(){
        var h = Common.$container.find('.nav-toggle>.wrapper>nav>ul').outerHeight();
        // var logoTop = Common.$container.find('.center a.logo').offset().top;
        // var navTop = Common.$container.find('.nav-toggle>.wrapper').offset().top;
        // if(navTop + h + 30 > logoTop){
        //     anime({
        //         targets: Common.$container.find('.menu-bar .center')[0],
        //         translateY: navTop + h + 30 - logoTop,
        //         easing: 'easeOutCubic',
        //         duration: 800
        //     });
        // }
        // anime.set({
        //     targets: Common.$container.find('.nav-toggle>.wrapper>nav')[0],
        //     height: h,
        //     easing: 'easeOutCubic',
        //     duration: 800
        // });
        Common.$container.find('.nav-toggle>.wrapper>nav').height(h);
    },
    closeNav: function(){
        Common.$container.find('.nav-toggle>.wrapper>nav').height(5);

        anime({
            targets: Common.$container.find('.menu-bar .center')[0],
            translateY: 0,
            easing: 'easeOutCubic',
            duration: 800
        });
    },
    toggleNav: function(){
        var $toggle = Common.$container.find('.nav-toggle');
        if($toggle.hasClass('active')){
            Common.closeNav();
        }else{
            Common.openNav();
        }
        $toggle.toggleClass('active');
    },
    arrowAnimation: function(){
        // $(document).find('.scroll-indicator.down').each(function(){
        //     var $this = $(this);
        //     anime({
        //         targets: $this[0],

        //     });
        // });
    },
    toggleMenu: function(){
        if(!$('#header').hasClass('menu-opened')){
            Common.openMenu();
        }else{
            Common.closeMenu();
        }
    },
    openMenu: function(){
        // clearTimeout(Common.menuStatus);
        // if(!$('.menu-bar').hasClass('animating')){
            // $('.menu-bar .indicator').removeClass('active');
            if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                // anime.set($('.menu-bar')[0], {
                //     translateX: -250,
                // });
                $('#header').addClass('menu-opened');
                var height = $(window).height();
                $('.menu-bar').height(height);
                Common.openNav();
            }else{
                anime.set($('.menu-bar')[0], {
                    translateX: -250,
                });
                anime({
                    targets: $('.menu-bar')[0],
                    translateX: 0,
                    duration: 600,
                    easing: 'easeOutQuart',
                    // before: function(){
                    //     $('.menu-bar').addClass('animating');
                    // },
                    before: function(){
                        // $('.menu-bar').removeClass('animating');
                        $('#header').addClass('menu-opened');
                    }
                });
            }
            

            
            // anime({
            //     targets: $('footer .disclaimer')[0],
            //     paddingLeft: 220,
            //     duration: 600,
            //     easing: 'easeOutQuart',
            // });
            // anime({
            //     targets: Common.$container.find('#main')[0],
            //     marginLeft: 250,
            //     duration: 600,
            //     easing: 'easeOutQuart'
            // });
            // if(Common.$container.data('template') === 'home'){
            //     anime({
            //         targets: Common.$container.find('.center-text')[0],
            //         width: $(window).width() - 250,
            //         duration: 600,
            //         easing: 'easeOutQuart'
            //     });
            // }
        // }
    },
    closeMenu: function(e){
        // return new Promise(function(resolve){
            if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
                $('#header').removeClass('menu-opened');
                $('.menu-bar').height(40);
            }else{
                anime({
                    targets: $('.menu-bar')[0],
                    translateX: -267,
                    duration: 600,
                    easing: 'easeOutQuart',
                    // before: function(){
                    //     $('.menu-bar').addClass('animating');
                    // },
                    // complete: function(){
                    //     $('.menu-bar').removeClass('animating');
                    // }
                    before: function(){
                        // $('.menu-bar').removeClass('animating');
                        $('#header').removeClass('menu-opened');
                    }
                });
            }
            
            // if(e === true){
            //     $('.menu-bar').css({
            //         transform: 'translateX(-250px)'
            //     });
            //     $('footer .disclaimer').css({
            //         paddingLeft: 0
            //     });
            //     Common.$container.find('#main').css({
            //         marginLeft: 30
            //     });
            //     $('.menu-bar .indicator').addClass('active');
            // }else if(!$('.menu-bar').hasClass('animating') && e.target.tagName !== 'A' && Common.$container.data('template') !== 'home'){
            //     Common.startCloseMenuAnimation(resolve);
            // }else if($('.menu-bar').hasClass('animating') && e.target.tagName !== 'A' && Common.$container.data('template') !== 'home'){
            //     Common.menuStatus = setTimeout(function(){
            //         Common.startCloseMenuAnimation(resolve);
            //     }, 1500);
            // }
        // });
    },
    // startCloseMenuAnimation: function(resolve){
    //     anime({
    //         targets: $('.menu-bar')[0],
    //         translateX: -220,
    //         duration: 600,
    //         easing: 'easeOutQuart',
    //         before: function(){
    //             $('.menu-bar').addClass('animating');
    //         },
    //         complete: function(){
    //             $('.menu-bar .indicator').addClass('active');
    //             $('.menu-bar').removeClass('animating');
    //             resolve();
    //         }
    //     });
    //     anime({
    //         targets: $('footer .disclaimer')[0],
    //         paddingLeft: 0,
    //         duration: 600,
    //         easing: 'easeOutQuart',
    //     });
    //     anime({
    //         targets: Common.$container.find('#main')[0],
    //         marginLeft: 30,
    //         duration: 600,
    //         easing: 'easeOutQuart'
    //     });
    //     if(Common.$container.data('template') === 'home'){
    //         anime({
    //             targets: Common.$container.find('.center-text')[0],
    //             width: $(window).width() - 30,
    //             duration: 600,
    //             easing: 'easeOutQuart'
    //         });
    //     }
    // },
    detectDevice: function(){
        // $(window).on('mouseover', function onFirstHover() {
        //     $('html').addClass('desktop').removeClass('mobile');
        //     $(window).off('mouseover', onFirstHover, false);
        // });
        if(!('ontouchstart' in window)){
            $('html').addClass('desktop').removeClass('mobile');
        }
    },
    detectIE: function() {
        var isIE = false;
        var ua = window.navigator.userAgent;

        if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) isIE = true;

        if(isIE) $('html').addClass('ie');

    },
    isMobile: function(){
        // return window.matchMedia('(max-width: 768px) and (orientation: portrait)').matches || window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches;
        if(!('ontouchstart' in window)){
            return false;
        }
        return true;
    },
    menuShrink: function(){
        // if(window.matchMedia('(max-width: 767px)').matches){
        //  if($(window).scrollTop() > 50 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 50 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else if(window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches){
        //  if($(window).scrollTop() > 60 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //  }else if($(window).scrollTop() <= 60 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //  }
        //  TweenLite.set('#header-body-center .logo-complete', {display: 'none'});
        //  TweenLite.set('#header-body-center .logo-simple', {display: 'block', autoAlpha: 1});
        // }else{
        //  if($(window).scrollTop() > 200 && !$('html').hasClass('scrolled')){
        //      $('html').addClass('scrolled');
        //      var expand = new TimelineMax();
        //      expand.to('#header-body-center .logo', 0.3, {'width': 179, height:32, ease:Power3.easeOut}, 0);
        //  }else if($(window).scrollTop() <= 200 && $('html').hasClass('scrolled')){
        //      $('html').removeClass('scrolled');
        //      var shrink = new TimelineMax();
        //      shrink.to('#header-body-center .logo', 0.3, {'width': 256, height:102, ease:Power3.easeOut}, 0);
        //  }
        // }
        
    },
    
    beautifyScrollbar: function(){
        // var $dropdown = $('.select2-dropdown .select2-results__options');
        // var $container = $dropdown.parents('.select2-dropdown');
        // TweenLite.set($container, {autoAlpha: 0});
        // if($dropdown.length > 1){
        //  $dropdown.last().mCustomScrollbar('destroy');
        // }else $dropdown.mCustomScrollbar('destroy');
        // setTimeout(function() {
        //  $dropdown.mCustomScrollbar({
        //      advanced:{
        //          updateOnContentResize: true
        //      },
        //      theme:"dark-2",
        //      scrollInertia: 200
        //  });
            
        //  TweenLite.to($container, 0.3, {autoAlpha: 1, ease: Power4.easeout});
        // }, 0);
    },
    throttle: function(a,b){var c,d;return function(){var e=this,f=arguments,g=+new Date;c&&g<c+a?(clearTimeout(d),d=setTimeout(function(){c=g,b.apply(e,f)},a)):(c=g,b.apply(e,f))}},
    debounce: function(a,b,c){var d,e;return function(){function h(){d=null,c||(e=a.apply(f,g))}var f=this,g=arguments;return clearTimeout(d),d=setTimeout(h,b),c&&!d&&(e=a.apply(f,g)),e}},

    imagesZoom: function(e){
        e.preventDefault();
        var $this = $(e.currentTarget);console.log($this.closest('.ps-wrapper'));
        var $wrapper = $this.closest('.ps-wrapper').length ? $this.closest('.ps-wrapper') : $this.closest('.section');
        var $image = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image');
        var index = $wrapper.find('.ps-image:visible, .desktop-hide .ps-image, .mobile-hide .ps-image').index($this);
        var items = [];
        $image.each(function(){
            const src = $(this).data("ps-src") || $(this).attr("src");
            const w = $(this).data("ps-w") || this.naturalWidth;
            const h = $(this).data("ps-h") || this.naturalHeight;
            var caption = $(this).data("ps-caption") || '';
            caption = caption.split(' - ');
            if(caption.length === 2){
                caption = caption[0] + '<br>' + caption[1];
            }else{
                caption = caption[0];
            }
            items.push({
                src: src,
                w: w,
                h: h,
                msrc: src,
                title: caption
            });
        });
        var $pswp = $('.pswp')[0];
        var options = {
                index: index,
                bgOpacity: 0.95,
                // showHideOpacity: true,
                // showAnimationDuration: 2000,
                history: false,
                // fullscreenEl: true,
                shareEl: false,
                // counterEl: false,
                // closeOnScroll: false,
                scaleMode: 'fit',
                // getThumbBoundsFn: function(i) {
                //     var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                //     var rect = $image[i].getBoundingClientRect();
                //     return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                // }
        }
        var ps = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        ps.init();
    },
    mobileShare: function(e){
        e.preventDefault();
        var url = document.location.href;
        if (navigator.share) {
          navigator.share({
              url: url
          });
        }
    },
    video2Cover: function(){
        if(Common.$container){
            Common._video2Cover();
            clearTimeout(Common.resize);
            Common.resize = setTimeout(function(){
                Common._video2Cover();
            }, 500);
            
        }
    },
    _video2Cover: function(){
        var $videos = Common.$container.find('.cover-video');
        $videos.each(function(){
            var $this = $(this);
            var parentWidth = $this.parent().outerWidth();
            var parentHeight = $this.parent().outerHeight();
            var aspectRatio = $this.data('ratio') ? $this.data('ratio') : 1.2;
            var newHeight, newWidth, halfWidth, halfHeight;
            if(parentWidth / parentHeight > aspectRatio){
                if(newWidth > parentWidth){
                    newWidth = parentHeight*aspectRatio;
                    newHeight = newWidth/aspectRatio;
                    halfWidth = newWidth/2;
                    $this.css({
                        "height": newHeight,
                        "width":newWidth,
                        "left":"50%",
                        "top":"auto",
                        "transform": "translate(-"+halfWidth+"px, 0)"
                    });
                }else{
                    newHeight = parentWidth/aspectRatio;
                    newWidth = newHeight*aspectRatio;
                    halfHeight = newHeight/2;
                    $this.css({
                        "height":newHeight,
                        "width": newWidth,
                        "left": 0,
                        "top":"50%",
                        "transform": "translate(0, -"+halfHeight+"px)"
                    });
                }
            }else{
                newHeight = parentHeight;
                newWidth = newHeight*aspectRatio;
                halfWidth = newWidth/2;
                $this.css({
                    "height":newHeight,
                    "width":newWidth,
                    "left":"50%",
                    "top": 0,
                    "transform": "translateX(-"+halfWidth+"px)"
                });
            }
                
        });
    }
    
}


var Home = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'home',
        onEnter: function() {
            Home.$container = $(this.container);

            
            if($('html').hasClass('landing')){

                
            }

            // events
            Home.$container.find('.left').on('mouseenter', function(){
                if($('html').hasClass('desktop')){
                    $(this).addClass('hover');
                }
                
            });

            Home.$container.find('.left').on('mouseleave', function(){
                if($('html').hasClass('desktop')){
                    $(this).removeClass('hover');
                }
            });

            Home.$container.find('.right').on('mouseenter', function(){
                if($('html').hasClass('desktop')){
                    $(this).addClass('hover');
                }
            });

            Home.$container.find('.right').on('mouseleave', function(){
                if($('html').hasClass('desktop')){
                    $(this).removeClass('hover');
                }
            });

            Home.$container.find('.content-wrapper .wrapper').on('click', function(){
                Home.$container.find('.left, .right').not($(this).closest('.left, .right')).removeClass('active');
                if($(this).closest('.left, .right').hasClass('active')){
                    $(this).closest('.left, .right').removeClass('active');
                }else{
                    $(this).closest('.left, .right').addClass('active');
                }
            });

            $(window).on('resize orientationschange',  function(){
                Common.fitMain();
            }).trigger('resize');
        },
        onEnterCompleted: function() {
            Common.pageTransitionEnter(Home.$container).then(function(){


                $(window).trigger('resize');
            
            });
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {

        }
    }),
    resize: function(){

    }
}

var About = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-about',
        onEnter: function() {
            About.$container = $(this.container);

            new Swiper (About.$container.find('.swiper-container')[0], {
              slidesPerView: 1,
              // simulateTouch: false,
              autoplay: true,
              navigation: {
                nextEl: About.$container.find('.swiper-container .swiper-button-next')[0],
                prevEl: About.$container.find('.swiper-container .swiper-button-prev')[0],
              },
              // on: {
              //   slideChangeTransitionStart: function(){
              //     var activeIndex = this.activeIndex;
              //     $(subSlider.slides).removeClass('is-selected');
              //     $(subSlider.slides).eq(activeIndex).addClass('is-selected');
              //     subSlider.slideTo(activeIndex,300, false);
              //   }
              // }
            });
            // events
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(About.$container);
        },
        onLeave: function() {

        },
        onLeaveCompleted: function() {
        }
    })
}



var Location = {
    $container: null,
    map: null,
    point: null,
    point2: null,
    google_map: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-location',
        onEnter: function() {
            Location.$container = $(this.container);

            window.initMap = function() {

               var lat = 22.276272;
              var lng = 114.168477;
              Location.point = new google.maps.LatLng(parseFloat(lat),parseFloat(lng));
              
              if(Location.$container.find('#main').hasClass('sa')){
                Location.map = new google.maps.Map(Location.$container.find('#google-map')[0], {
                  center: Location.point,
                  scrollwheel: false,
                  zoom: 19,
                });
              }else if ( $(window).width() > 1024 ) {
              
                  Location.map = new google.maps.Map(Location.$container.find('#google-map')[0], {
                    center: Location.point,
                    scrollwheel: false,
                    zoom: 18,
                  });
              }else{
                  Location.map = new google.maps.Map(Location.$container.find('#google-map')[0], {
                    center: Location.point,
                    scrollwheel: false,
                    zoom: 16,
                  });
              }
            }

            Common.loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBjZD9Ysiq5nqEFLFpsMi0i4eOVgckfB4s&callback=initMap&language=en").then(function(){

                  

                  if(Location.$container.find('#main').hasClass('sa')){
                    var image = {
                      url: '/wp-content/themes/assemblyss/images/locator2.png',
                      size: new google.maps.Size(64, 70),
                      origin: new google.maps.Point(0,0),
                      anchor: new google.maps.Point(64,141),
                    };

                    new google.maps.Marker({
                        position: new google.maps.LatLng(22.276532,114.168740),//SA1
                        map: Location.map,
                        icon: image
                    });

                    new google.maps.Marker({
                        position: new google.maps.LatLng(22.276221,114.168616),//SA2
                        map: Location.map,
                        icon: image
                    });

                    new google.maps.Marker({
                        position: new google.maps.LatLng(22.276288,114.168950),//SA3
                        map: Location.map,
                        icon: image
                    });

                    new google.maps.Marker({
                        position: new google.maps.LatLng(22.276154,114.169338),//SA4
                        map: Location.map,
                        icon: image
                    });
                  }else{
                    var image = {
                      url: '/wp-content/themes/assemblyss/images/locator.png',
                      size: new google.maps.Size(124, 70),
                      origin: new google.maps.Point(0,0),
                      anchor: new google.maps.Point(120,115),
                    };

                    new google.maps.Marker({
                        position: new google.maps.LatLng(22.276635,114.168208),//SS
                        map: Location.map,
                        icon: image
                    });
                  }
                  

                

                
                      
                Location.$container.find('input[name="map"]').on('change', function(){
                    var index = $(this).val();
                    Location.$container.find('.map').removeClass('active');
                    Location.$container.find('.map').eq(index).addClass('active');
                });
            });

            
        },
        onEnterCompleted: function() {
            Common.script.parentNode.removeChild( Common.script );
            Common.pageTransitionEnter(Location.$container);
        },
        onLeave: function() {

            Location.map = null;
        },
        onLeaveCompleted: function() {
        }
    })
    
}

    

var Live = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-live',
        onEnter: function() {
            Live.$container = $(this.container);


        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Live.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Life = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-life',
        onEnter: function() {
            Life.$container = $(this.container);

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('o') === '1') {
                const offerElement = document.getElementById('offer');
                if (offerElement) {
                    scrollTo({
                        top: offerElement.offsetTop,
                        behavior: 'instant'
                    });
                    setTimeout(() => {
                    scrollTo({
                        top: offerElement.offsetTop,
                        behavior: 'instant'
                    });
                }, 500);
                }
            }

            new Swiper (Life.$container.find('.swiper-container')[0], {
              slidesPerView: 1,
              // simulateTouch: false,
              autoplay: true,
              navigation: {
                nextEl: Life.$container.find('.swiper-container .swiper-button-next')[0],
                prevEl: Life.$container.find('.swiper-container .swiper-button-prev')[0],
              },
              // on: {
              //   slideChangeTransitionStart: function(){
              //     var activeIndex = this.activeIndex;
              //     $(subSlider.slides).removeClass('is-selected');
              //     $(subSlider.slides).eq(activeIndex).addClass('is-selected');
              //     subSlider.slideTo(activeIndex,300, false);
              //   }
              // }
            });

            Common.loadScript("https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js").then(function(){
                Life.$container.find('.list').masonry({
                    itemSelector: '.card',
                    columnWidth:'.grid-sizer',
                    gutter: '.gutter-sizer',
                    percentPosition: true
                  })
            });
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(Life.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var More = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-more',
        onEnter: function() {
            More.$container = $(this.container);

            More.$container.find('.swiper-container').each(function(){
                var that = this;
                new Swiper (this, {
                  slidesPerView: 1,
                  // simulateTouch: false,
                  observer: true,
                  observeParents: true,
                  // autoplay: true,
                  watchOverflow: true,
                  navigation: {
                    nextEl: $(that).find('.swiper-button-next')[0],
                    prevEl: $(that).find('.swiper-button-prev')[0],
                  },
                  pagination: {
                    el: $(that).find('.swiper-pagination')[0],
                    clickable: true
                  },
                  on: {
                    init: function(){
                      if(this.slides.length < 2){
                        $(that).find('.swiper-button-next').hide();
                        $(that).find('.swiper-button-prev').hide();
                      }
                    }
                  }
                });
            });
            

            // events
            More.$container.find('input[name="room"]').on('change', function(){
                var index = $(this).val();
                More.$container.find('.indicator').removeClass('active');
                More.$container.find('.indicator').eq(index).addClass('active');
                More.$container.find('.room-detail').removeClass('active');
                More.$container.find('.room-detail[data-room="'+index+'"]').addClass('active');
            });

            // More.$container.find('.place').on('click', function(){
            //     More.$container.find('.place').removeClass('active');
            //     $(this).addClass('active');

            //     var index = $(this).index();
            //     More.$container.find('.indicator').removeClass('active');
            //     More.$container.find('.indicator').eq(index).addClass('active');
            // });

            More.$container.find('.indicator').on('click', function(){
                var room = $(this).data('room');
                var $target = More.$container.find('.room-detail[data-room="'+room+'"]');
                More.$container.find('.room-detail').removeClass('active');
               $target.addClass('active');

                const offset = $target.offset().top;
                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: offset,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            });

            More.$container.find('.tabs button').on('click', function(){
                var tab = $(this).data('tab');
                More.$container.find('.tabs button').removeClass('active');
                $(this).addClass('active');

                More.$container.find('.tab-section').removeClass('active');
                More.$container.find('.tab-section[data-tab="'+tab+'"]').addClass('active');

                var $target = More.$container.find('.room-details');
                const offset = $target.offset().top;
                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: offset,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            });

            More.$container.find('input[name="map"]').on('change', function(){

                var tab = $(this).val();
                More.$container.find('.tabs button').removeClass('active');
                $(this).addClass('active');

                More.$container.find('.tab-section').removeClass('active');
                More.$container.find('.tab-section[data-tab="'+tab+'"]').addClass('active');

                var $target = More.$container.find('.room-details');
                const offset = $target.offset().top;
                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: offset,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            });

            More.$container.find('.open-popup').on('click', function(e){
                var $content = $(e.currentTarget).find('.scrollable-popup-content');
                var popup = new ScrollablePopup();
                popup.open($content);
            });
        },
        onEnterCompleted: function() {
            
            Common.pageTransitionEnter(More.$container);
        },
        onLeave: function() {
            More.$container.find('.place').off('click');
        },
        onLeaveCompleted: function() {
        }
    })
}

var Your = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-home',
        onEnter: function() {
            Your.$container = $(this.container);

            Your.$container.find('.swiper-container').each(function(){
                new Swiper (this, {
                  slidesPerView: 1,
                  observer: true,
                  observeParents: true,
                  // simulateTouch: false,
                  // autoplay: true,
                  navigation: {
                    nextEl: $(this).find('.swiper-button-next')[0],
                    prevEl: $(this).find('.swiper-button-prev')[0],
                  },
                  pagination: {
                    el: $(this).find('.swiper-pagination')[0],
                    clickable: true
                  },
                  // on: {
                  //   slideChangeTransitionStart: function(){
                  //     var activeIndex = this.activeIndex;
                  //     $(subSlider.slides).removeClass('is-selected');
                  //     $(subSlider.slides).eq(activeIndex).addClass('is-selected');
                  //     subSlider.slideTo(activeIndex,300, false);
                  //   }
                  // }
                });
            });
            

            // event
            Your.$container.find('.room').on('click', function(){
                var room = $(this).data('room');
                var $target = Your.$container.find('.room-detail[data-room="'+room+'"]');
                Your.$container.find('.room-detail').removeClass('active');
               $target.addClass('active');

                const offset = $target.offset().top;
                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: offset,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            });

            Your.$container.find('.tabs button').on('click', function(){
                var tab = $(this).data('tab');
                Your.$container.find('.tabs button').removeClass('active');
                $(this).addClass('active');

                Your.$container.find('.tab-section').removeClass('active');
                Your.$container.find('.tab-section[data-tab="'+tab+'"]').addClass('active');

                var $target = Your.$container.find('.room-details');
                const offset = $target.offset().top;
                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: offset,
                    duration: 500,
                    easing: 'easeOutQuad'
                });
            });

            // Your.$container.find('input[name="map"]').on('change', function(){

            //     var tab = $(this).val();
            //     Your.$container.find('.tabs button').removeClass('active');
            //     $(this).addClass('active');

            //     Your.$container.find('.tab-section').removeClass('active');
            //     Your.$container.find('.tab-section[data-tab="'+tab+'"]').addClass('active');

            //     var $target = Your.$container.find('.room-details');
            //     const offset = $target.offset().top;
            //     anime({
            //         targets: [document.documentElement, document.body],
            //         scrollTop: offset,
            //         duration: 500,
            //         easing: 'easeOutQuad'
            //     });
            // });

            Your.$container.find('input[name="room"]').on('change', function(){

                var room = $(this).val();
                // Your.$container.find('.tabs button').removeClass('active');
                // $(this).addClass('active');

                // Your.$container.find('.tab-section').removeClass('active');
                // Your.$container.find('.tab-section[data-tab="'+tab+'"]').addClass('active');
                var $target = Your.$container.find('.room-detail[data-room="'+room+'"]');
                Your.$container.find('.room-detail').removeClass('active');
                $target.addClass('active');


                Your.$container.find('.open-popup').removeClass('active');
                Your.$container.find('.open-popup[data-id="'+ room +'"]').addClass('active');

                // var $scrollTarget = Your.$container.find('.room-details');
                // const offset = $scrollTarget.offset().top;
                // anime({
                //     targets: [document.documentElement, document.body],
                //     scrollTop: offset,
                //     duration: 500,
                //     easing: 'easeOutQuad'
                // });
            });

            Your.$container.find('.open-popup').on('click', function(e){
                var $content = $(e.currentTarget).find('.scrollable-popup-content');
                var popup = new ScrollablePopup();
                popup.open($content);
            });
        },
        onEnterCompleted: function() {
            Your.$container = $(this.container);
            Common.pageTransitionEnter(Your.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Terms = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-terms',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Terms.$container = $(this.container);
            Common.pageTransitionEnter(Terms.$container);
            $(window).on('resize orientationschange',  function(){
                Common.fitMain();
            }).trigger('resize');
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Book = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-book',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Book.$container = $(this.container);
            Common.pageTransitionEnter(Book.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Film = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-film',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Film.$container = $(this.container);
            Common.pageTransitionEnter(Film.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Availability = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'page-availability',
        onEnter: function() {
            Availability.$container = $(this.container);
            Availability.$container.find('.open-popup').on('click', function(e){
                var $content = $(e.currentTarget).find('.scrollable-popup-content');
                var popup = new ScrollablePopup();
                popup.open($content);
            });
        },
        onEnterCompleted: function() {
            Availability.$container = $(this.container);
            Common.pageTransitionEnter(Availability.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Dummy = {
    $container: null,
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'dummy',
        onEnter: function() {

        },
        onEnterCompleted: function() {
            Dummy.$container = $(this.container);
            Common.pageTransitionEnter(Dummy.$container);
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var P404 = {
    init: function(){
        this.View.init();
    },
    View: Barba.BaseView.extend({
        namespace: 'http404',
        onEnter: function() {
            Common.pageTransitionEnter();
        },
        onEnterCompleted: function() {
        },
        onLeave: function() {
        },
        onLeaveCompleted: function() {
        }
    })
}

var Polyfill = {
    init: function(){
        if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            };
        }
    }
}

$(function(){
    Polyfill.init();
    Common.init();

    Home.init();
    About.init();
    Location.init();
    Live.init();
    Life.init();
    More.init();
    Your.init();
    Terms.init();
    Book.init();
    Film.init();
    Availability.init();
    
    P404.init();
    Barba.Pjax.init();
});


class ScrollablePopup {
    constructor() {
        this.top = 0;
        this.$parent = null;
        this.$content = null;
        this.markup = "<div class='scrollable-popup'><div class='overlay close'></div><div class='content'></div></div>";
        this.$popup = null;
        this.eventQueue = {};
        Common.popupInstances.push(this);
    }

    open($element, popupClass){
        var _this = this;
        _this.$parent = $element.parent();
        _this.$content = $element;
        _this.$contener = Common.popupInstances.length > 1 ? Common.popupInstances[Common.popupInstances.length - 2].$popup : $element.closest('.transition-container');
        if(Common.sidebarInstances.length > 0) _this.$contener = Common.sidebarInstances[Common.sidebarInstances.length - 1].$sidebar;
        _this.top = $(document).scrollTop();
        _this.$contener.css({
            position: "fixed",
            top: -_this.top,
            overflow: "hidden"
        });
        // $(".sticky").css({
        //  position: "fixed",
        //  top: 0
        // });
        _this.$popup = $(_this.markup).clone();
        _this.$popup.addClass(popupClass);
        _this.$popup.find('.content').append($element);

        $("body").append(_this.$popup);
        $(document).scrollTop(0);

        anime.timeline({
            easing: 'easeOutCubic'
        }).add({
            targets: _this.$popup[0],
            opacity: [0,1],
            duration: 200
        }).add({
            targets: _this.$popup.find('.content')[0],
            opacity: [0,1],
            translateY: [40, 0],
            duration: 500
        });

        _this.$popup.find('.close').on('click touch',function(){
            _this.close();
        });
    }

    close(goTop){
        if($(".scrollable-popup").length){
            var _this = this;
            var top = goTop ? 0 : this.top;
            anime({
                targets: this.$popup[0],
                opacity: 0,
                easing: 'easeOutCubic',
                duration: 200,
                complete: function(){
                    _this.$parent.append(_this.$content);
                    _this.$popup.remove();
                    _this.$contener.css({
                        position: "relative",
                        top: "auto",
                        overflow: ""
                    });
                    // $(".sticky").css({
                    //  position: "sticky",
                    //  top: "auto"
                    // });
                    $(document).scrollTop(top);
                    _this.destroy();

                    if(!$('html').hasClass('ie')) _this.trigger('close');

                    if(_this.eventQueue['close']) _this.eventQueue['close'] = [];
                }
            });
        }
    }

    once(event, callback){
        if(!this.eventQueue[event])
            this.eventQueue[event] = [];
        this.eventQueue[event].push(callback);
    }

    trigger(event, params){
        if(this.eventQueue[event]) {
            for(var i in this.eventQueue[event])
                this.eventQueue[event][i](params);
        }
    }

    destroy(){
        var i = Common.popupInstances.indexOf(this);
        Common.popupInstances.splice(i, 1);
        delete this;
    }
}
